/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnumDictionary, DictionaryParams } from '@gh/common-shared';
import { get } from 'lodash';
import { OfficeMeasurement, OfficeMeasurementDefault, OfficeType } from './offices';
import { ApplicationView } from './profiles';
import { UserStatus } from './users';

const officeStatusByViewAndStatus = {
  [ApplicationView.Corporate]: {
    [UserStatus.Active]: {
      [UserStatus.Active]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
    [UserStatus.Inactive]: {
      [UserStatus.Active]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
  },
  [ApplicationView.Master]: {
    [UserStatus.Active]: {
      [UserStatus.Active]: true,
      [UserStatus.Transferred]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
    [UserStatus.Inactive]: {
      [UserStatus.Active]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
  },
  [ApplicationView.Office]: {
    [UserStatus.Active]: {
      [UserStatus.Active]: true,
      [UserStatus.Transferred]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
    [UserStatus.Inactive]: {
      [UserStatus.Active]: true,
      [UserStatus.Inactive]: true,
      [UserStatus.Deleted]: true,
    },
  },
};

const officeTypeByView = {
  [ApplicationView.Corporate]: {
    [OfficeType.Master]: true,
  },
  [ApplicationView.Master]: {
    [OfficeType.Franchise]: true,
    [OfficeType.Template]: true,
    [OfficeType.Training]: true,
  },
};

const officeMeasurementDefaultByMeasurement = {
  [OfficeMeasurement.Metric]: {
    [OfficeMeasurementDefault.Meter]: true,
    [OfficeMeasurementDefault.Millimeter]: true,
  },
  [OfficeMeasurement.Imperial]: {
    [OfficeMeasurementDefault.Foot]: true,
  },
};

export const DICTIONARY_TEMPLATES = 'TEMPLATES';
export const DICTIONARY_TIMEZONES = 'TIMEZONES';

export const DICTIONARY_USER_STATUS_FOR_EDIT = createEnumDictionary(UserStatus,
                                                                    (item, _1, _2, params: DictionaryParams) =>
    <boolean>get(
      officeStatusByViewAndStatus,
      [params['applicationView'], params['status']],
      { [item.id]: true })[item.id]);

export const DICTIONARY_OFFICE_TYPE_FOR_EDIT = createEnumDictionary(OfficeType,
                                                                    (item, _1, _2, params: DictionaryParams) =>
    officeTypeByView[params['applicationView']][item.id]);

export const DICTIONARY_OFFICE_MEASUREMENT_DEFAULT_FOR_EDIT = createEnumDictionary(
  OfficeMeasurementDefault,
  (item, _1, _2, params: DictionaryParams) => officeMeasurementDefaultByMeasurement[params['measurement']][item.id],
);
